/**
 * Created by Swaniti-Initiative on 4/18/18.
 */
import { Injectable } from '@angular/core';
import { Subject } from 'rxjs/Subject';
import { Observable } from 'rxjs/Observable';
import { QuestionnaireDetail } from '../../classes/questionnaireDetail';
import { BehaviorSubject } from 'rxjs';

@Injectable()
export class TabsDataService {

  constructor() { }

  private surveyTabData:QuestionnaireDetail[];
  private teamsTabData:any;
  private surveyorTabData:any;
  private responsesTabData:any;
  private analyticsDateUserTabData:any;
  private analyticsDateLevelTabData:any;
  private superAdminManagerTabData:any;
  private surveyTabDataTobeUpdated:boolean = true;
  private teamTabDataTobeUpdated:boolean = true;
  private surveyorDataTobeUpdated:boolean = true;
  private dateUserAnalyticsDataTobeUpdated:boolean = true;
  private dateLevelAnalyticsDataTobeUpdated:boolean = true;
  private superAdminTabDataTobeUpdated:boolean = true;

  private subject: Subject<boolean> = new Subject<boolean>();
  createNewForm = new BehaviorSubject<boolean>(false);

  setSurveyTabData(surveyTabData: QuestionnaireDetail[]): void {
    this.surveyTabData = surveyTabData;
  }

  getSurveyTabData(): QuestionnaireDetail[] {
    return this.surveyTabData;
  }

  setTeamsTabData(teamsTabData):void {
    this.teamsTabData = teamsTabData;
  }

  getTeamsTabData():any {
    return this.teamsTabData;
  }

  setSurveyorTabData(surveyorTabData): void {
    this.surveyorTabData = surveyorTabData;
  }

  getSurveyorTabData():any{
    return this.surveyorTabData;
  }

  setResponsesTabData(responsesTabData):void{
    this.responsesTabData = responsesTabData;
  }

  getResponsesTabData():Observable<boolean>{
    return this.responsesTabData;
  }

  setDateUserAnalyticsTabData(analyticsDateUserTabData:any):void{
    this.analyticsDateUserTabData = analyticsDateUserTabData;
  }

  getDateUserAnalyticsTabData():Observable<boolean>{
    return this.analyticsDateUserTabData;
  }

  setDateLevelAnalyticsTabData(analyticsDateLevelTabData:any):void{
    this.analyticsDateLevelTabData = analyticsDateLevelTabData;
  }

  getDateLevelAnalyticsTabData():Observable<boolean>{
    return this.analyticsDateLevelTabData;
  }

  setSuperadminManagerTabData(superAdminManagerTabData):void{
      this.superAdminManagerTabData = superAdminManagerTabData;
  }

  getSuperadminManagerTabData(){
      return this.superAdminManagerTabData;
  }

  hasSurveyTabDataTobeUpdated():boolean{
    return this.surveyTabDataTobeUpdated;
  }

  setSurveyTabDataTobeUpdated(value):void{
    this.surveyTabDataTobeUpdated = value;
  }

  hasTeamsTabDataTobeUpdated():boolean{
    return this.teamTabDataTobeUpdated;
  }

  setTeamsTabDataTobeUpdated(value):void{
    this.teamTabDataTobeUpdated = value;
  }

  hasSurveyorDataTobeUpdated():boolean{
    return this.surveyorDataTobeUpdated;
  }

  setSurveyorDataTobeUpdated(value):void{
    this.surveyorDataTobeUpdated = value;
  }

  hasDateUserAnalyticsDataTobeUpdated():boolean{
    return this.dateUserAnalyticsDataTobeUpdated;
  }

  setDateUserAnalyticsDataTobeUpdated(value):void{
    this.dateUserAnalyticsDataTobeUpdated = value;
  }

  hasDateLevelAnalyticsDataTobeUpdated():boolean{
    return this.dateLevelAnalyticsDataTobeUpdated;
  }

  setDateLevelAnalyticsDataTobeUpdated(value):void{
    this.dateLevelAnalyticsDataTobeUpdated = value;
  }

  hasSuperAdminManagerTabDataTobeUpdated():boolean{
      return this.superAdminTabDataTobeUpdated;
  }

  setSuperAdminManagerTabDataTobeUpdated(value):void{
      this.superAdminTabDataTobeUpdated = value;
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/services/tabs-data.service.ts